/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const AR_ALL_TBL_DATA = 'AR_ALL_TBL_DATA';
export const AR_ALL_FLD_DATA = 'AR_ALL_FLD_DATA';
export const AR_SGL_TBL_DATA = 'AR_SGL_TBL_DATA';
export const AR_SUMMERY_MFG_ALL_FIELD_CLEAR_REDUX =
  'AR_SUMMERY_MFG_ALL_FIELD_CLEAR_REDUX';
